import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AdminSidebar from '../../../dashboard/components/adminDashboard/AdminSidebar';
import Navbar from '../../../dashboard/components/dashboard/Navbar';
import { FaBars } from 'react-icons/fa';
import CashbotChat from '../cashbot/components/CashbotChat';
import { loadWidgets } from '../../../../app/store/slices/adminSlice';
import { loadPersistedWidgets } from '../../../../utils/widgetPersistence';

const AdminDashboardLayout = () => {
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeSection, setActiveSection] = useState('analytics');

  useEffect(() => {
    // Load persisted widgets on mount
    const persistedWidgets = loadPersistedWidgets();
    if (persistedWidgets.length > 0) {
      dispatch(loadWidgets(persistedWidgets));
    }
  }, [dispatch]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="min-h-screen overflow-hidden bg-gray-50">
      <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <Navbar onToggleSidebar={toggleSidebar} isAdmin={true} />
      </div>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="pt-[80px] flex min-h-[calc(100vh-80px)] relative">
        {/* Sidebar Container */}
        <div className={`
          fixed left-0 bottom-0 top-20 mt-8 pr-4 md:bg-transparent
          transform transition-transform duration-300 ease-in-out z-40
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-60'}
          w-[230px] md:w-64
        `}>
          <div className="h-full flex flex-col overflow-hidden">
            <div className="flex-shrink-0 overflow-y-auto custom-scrollbar">
              <AdminSidebar 
                activeSection={activeSection}
                onSectionChange={(section) => {
                  setActiveSection(section);
                  if (window.innerWidth < 768) setIsSidebarOpen(false);
                }}
              />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className={`flex-1 overflow-y-auto ${isSidebarOpen ? 'md:ml-60' : ''} min-h-[calc(100vh-80px)]`}>
          <main className="p-4 bg-gray-50">
            <Outlet context={[activeSection, setActiveSection]} />
          </main>
        </div>
          {/* Cashbot Components */}
          <div className="fixed bottom-4 right-4 z-50">
              <CashbotChat />
          </div>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;